import axios from "axios";
import { Base_URL } from "../url";

export const fetchCostCenterGroups = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CostCenterGroup/GetAllCostCenterGroups`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching cost center groups!";
  }
};

export const downloadCostCenterGroupsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/CostCenterGroup/DownloadCostCenterGroupsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading cost center groups data!";
  }
};